export default "__VITE_ASSET__377dc3ad__"